import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DISCLAIMERS } from '@app/core/const/disclaimers';
import * as fromRoot from '@app/store/reducers';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'am-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent {
  disclaimer: string[];

  private readonly _store = inject<Store<fromRoot.State>>(Store);

  constructor() {
    combineLatest([
      this._store.select(fromRoot.getDisclaimerToDisplay),
      this._store.select(fromRoot.getCurrentLang),
      this._store.select(fromRoot.getCountry),
    ])
      .pipe(takeUntilDestroyed())
      .subscribe(([disclaimerToDisplay, currentLang, country]) => {
        const matchedDisclaimer = DISCLAIMERS.find(disclaimer => disclaimer.displayOn === disclaimerToDisplay);
        this.disclaimer =
          matchedDisclaimer?.disclaimer[country] != null
            ? matchedDisclaimer.disclaimer[country][currentLang]
            : undefined;
      });
  }
}
